import React, { Component } from "react";
import "./rule.scss";
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
export default class postage extends React.Component {

    render() {
        return ( 
            <div className = { isiOS ? 'BulletprivacyHome IOSBulletprivacyHome' : 'BulletprivacyHome' }>
                <div className = "earnestMoney">
                    <h2> 邮费说明 </h2>
                    1、邮费：是指商品交易所需的邮费，卖家发布商品时可以设置包邮或者不包邮，不包邮情况下卖家必须填写邮费，包邮则填写邮费为0。< br/>
                    2、店铺满减包邮：若卖家店铺设置了满减包邮，买家在店铺内一次性消费达到商家设置的包邮金额，卖家包邮。若店铺未设置满减包邮，按卖家设置邮费支付对应邮费。< br/>
                    3、买家在购物车内一次性下单一个店铺内多个商品只会收取一次邮费，邮费不会累加，如每个商品邮费不同，取单商品邮费最高的作为本次快递费用。< br/>
                    4、发布买帖默认卖家包邮。< br/>
                </div>  
            </div>
        );
    }
}
